"use client";
import { jsx as _jsx } from "react/jsx-runtime";
import { Theme as RadixThemes } from "@radix-ui/themes";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import cx from "clsx";
import * as React from "react";
import { namespaceClassNames } from "./lib/utils";
import { DEFAULT_API_HOSTNAME } from "./lib/api/config";
import { WidgetsContext } from "./lib/widgets-context";
const queryClient = new QueryClient();
export const WorkOsWidgets = ({ elements = {}, className, theme: { fontFamily, ...radixThemesProps } = {}, style = {}, children, apiHostname = DEFAULT_API_HOSTNAME, port = null, https = true, }) => {
    const customStyle = (fontFamily
        ? {
            "--default-font-family": fontFamily,
            ...style,
        }
        : style);
    const apiBaseUrl = React.useMemo(() => {
        try {
            const url = new URL("/", `${https ? "https" : "http"}://${apiHostname}${port ? `:${port}` : ""}`);
            return url.toString().slice(0, -1);
        }
        catch {
            console.error("Failed to validate the WorkOS API URL. Check to ensure that valid `apiHostname` and `port` props are passed to WorkOsWidgets");
            return `https://${DEFAULT_API_HOSTNAME}`;
        }
    }, [apiHostname, https, port]);
    return (_jsx(QueryClientProvider, { client: queryClient, children: _jsx(RadixThemes, { ...radixThemesProps, style: customStyle, className: cx(namespaceClassNames("root"), className), children: _jsx(WidgetsContext.Provider, { value: { elements, apiBaseUrl }, children: children }) }) }));
};
//# sourceMappingURL=workos-widgets.client.js.map